import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as Highcharts from 'highcharts/highmaps';
import { SupportCaseSearchCriteria } from 'src/app/shared/model/searchCriteria';
import { ErrorService } from 'src/app/shared/services/error.service';
import { ItsmService } from 'src/app/shared/services/itsm.service';
import { Utilities } from 'src/app/shared/utilities';

@Component({
  selector: 'app-security-incident-timeline',
  templateUrl: './security-incident-timeline.component.html',
  styleUrls: ['./security-incident-timeline.component.scss']
})
export class SecurityIncidentTimelineComponent implements OnInit {

  //list
  //y-axis
  ocdCases = [ "new", "work in progress", "open", "on hold","pending (orange cyberdefense)", "pending ocd", "pending (ocd)", "pending vendor", "pending (vendor)", "resolved awaiting closure","answered awaiting closure", "closed", "investigating"]
  customerCases = ["pending customer", "pending (customer)"]
  yAxis = {}
  yAxisValue = {
    0: {
      ocdCases: 20,
      customerCases: 75
    },
    1: {
      ocdCases: 25,
      customerCases: 80
    },
    2: {
      ocdCases: 30,
      customerCases: 85
    },
    3: {
      ocdCases: 35,
      customerCases: 90
    }
  }
  
  // x-axis
  initialInvestigation = ["new", "work in progress", "investigating"]
  escalated = ["pending customer", "pending (customer)"]
  pendingOCD = ["open", "on hold", "pending (orange cyberdefense)", "pending ocd", "pending (ocd)", "pending vendor", "pending (vendor)"]
  closedInLastHours = ["resolved awaiting closure","answered awaiting closure", "closed"]
  xAxis = {}
  offset = 4;
  initialInvestigationInitial = 5;
  escalatedInitial = 30;
  pendingOCDInitial = 56;
  closedInLastHoursInitial = 82;
  xAxisValue = {
    0:{
      initialInvestigation: this.initialInvestigationInitial,
      escalated: this.escalatedInitial,
      pendingOCD: this.pendingOCDInitial,
      closedInLastHours: this.closedInLastHoursInitial
    },
    1:{
      initialInvestigation: this.initialInvestigationInitial + this.offset,
      escalated: this.escalatedInitial + this.offset,
      pendingOCD: this.pendingOCDInitial + this.offset,
      closedInLastHours: this.closedInLastHoursInitial + this.offset
    },
    2:{
      initialInvestigation: this.initialInvestigationInitial + 2* this.offset,
      escalated: this.escalatedInitial + 2* this.offset,
      pendingOCD: this.pendingOCDInitial + 2* this.offset,
      closedInLastHours: this.closedInLastHoursInitial + 2* this.offset
    },
    3:{
      initialInvestigation: this.initialInvestigationInitial + 3* this.offset,
      escalated: this.escalatedInitial + 3* this.offset,
      pendingOCD: this.pendingOCDInitial + 3* this.offset,
      closedInLastHours: this.closedInLastHoursInitial + 3* this.offset
    }
   
  }
  //Highcharts
  colors = ["#e75b60", "#ff7900","#ffd200","#4bb4e6"]
  Highcharts: typeof Highcharts = Highcharts;
 
  timeLineChart = {

    chart: {
        type: 'bubble',
        plotBorderWidth: 1,
        zoomType: 'xy'
    },

    title: {
        text: '',
    },
    credits: {
      enabled: false
    },
    xAxis: {
      gridLineColor: 'transparent',
      labels: {
        enabled: false
      },
      min:0,
      max:100,
      categories: [0, 10, 20, 30,40, 50,60, 70,80,90,100],
      gridLineWidth: 1,
        
    },

    yAxis: {
      gridLineColor: 'transparent',
      title: {
        enabled: false
      },
      labels: {
        enabled: false
      },
      tickAmount: 10,
        min:0,
        max:100,
        startOnTick: false
       
        
    },
    plotOptions: {
      series: {
        states: {
          hover: {
            enabled: true
          },
          inactive: {
            opacity:1
          },
          select : {
            enabled : true
          }
        },
        allowPointSelect:true,
        point : {
          events: {
            click : (e) => {
              this.showCases = []
               
              let priority = e.point.options.name.toLowerCase()
              this.cases.forEach((item)=> {
                let itemPriority = item.priority.split(' - ')[1].toLowerCase()

                if (e.point.options.stage.toLowerCase() == "under investigation" && itemPriority == priority){
                    if (this.initialInvestigation.indexOf(item.status.toLowerCase())!=-1){
                      this.showCases.push(item)
                  }
                }
                if (e.point.options.stage.toLowerCase() == "escalated" && itemPriority == priority){
                  if (this.escalated.indexOf(item.status.toLowerCase())!=-1){
                      this.showCases.push(item)
                  }
                }
                if (e.point.options.stage.toLowerCase() == "pending orange cyberdefense" && itemPriority == priority){
                  if (this.pendingOCD.indexOf(item.status.toLowerCase())!=-1){
                      this.showCases.push(item)
                  }
                }
                if (e.point.options.stage.toLowerCase() == "closed in last hours" && itemPriority == priority){
                  if (this.closedInLastHours.indexOf(item.status.toLowerCase())!=-1){
                    this.showCases.push(item)
                  }
                }
              })

            },
            select : () => null,
            unselect : (_) => null 
          }
        }
      },
      bubble: {
      }
  },
  tooltip: {
    useHTML: true,
    headerFormat: '',
    pointFormatter: function () { 
      const r = `"x" cases of "x" priority are currently under investigation by Orange Cyberdefense analysts`;
      return `
    <table><tr><th colspan="2" style="text-align: center">Cases</th></tr>
    <tr><td colspan="2"> <b>${this.z} Cases</b> of <span style="color: ${this.series.color}">${this.series.name}</span> priority are <b>${this.stage}</b></td></tr>
    <tr><td colspan="2">Detained by <b>${this.pendingAt}</b></td></tr>
    <tr><td colspan="2">${r}</td></tr>
    </table>`  },
  },
  series: []

}

  //Booleans
  displayTimeLineChart: boolean = false;
  updateDonutFlag: boolean = false;


  //Highchart Data
  chartData = {}

  //selectedPoint
  pointSelected = null

  //all cases
  cases: any[];
  showCases: any[] = [];

  //loading
  loading = true

  constructor(private itsmService: ItsmService,
    private errorService: ErrorService, 
    private translateService: TranslateService) { }

  ngOnInit(): void {
   

    let searchCriteria = new SupportCaseSearchCriteria();
    searchCriteria.createdFrom = Utilities.get1MonthAgo();
    searchCriteria.createdTo = Utilities.getToday();
    searchCriteria.securityAnaltyics = true;

    let cases = {};
    
    this.itsmService.getLiveReport(searchCriteria)
    .then(res=>{
      //console.log("res", res)
      let dic = {}
      this.cases = res;
      this.loading = false;

      // let tempData = res
      // let tempDataFinal = []
      // tempData.forEach((element, index) => {
      //   let temp = element
      //   if (index % 4 == 0){
      //     temp.status = "work in progress"
      //     tempDataFinal.push(temp)
      //   }
      //   if (index % 4 == 1){
      //     temp.status = "pending customer"
      //     tempDataFinal.push(temp)
      //   }
      //   if (index % 4 == 2){
      //     temp.status = "open"
      //     tempDataFinal.push(temp)
      //   }
      //   if (index % 4 == 3){
      //     temp.status = "resolved awaiting closure"
      //     tempDataFinal.push(temp)
      //   }
      // });

      // res = tempDataFinal

      let bussinessCritical = res.filter(a => a["priority"] == "1 - Business Critical");
      let high = res.filter(a => a["priority"] == "2 - High");
      let medium = res.filter(a => a["priority"] == "3 - Medium");
      let low = res.filter(a => a["priority"] == "4 - Low");


      this.calculatePriorityWiseData(bussinessCritical, 0, "Business Critical");
      this.calculatePriorityWiseData(high, 1, "High");
      this.calculatePriorityWiseData(medium, 2, "Medium");
      this.calculatePriorityWiseData(low, 3, "Low");
      //let trad = this.translateService('pages.generic.hello');

      let self = this;
      this.timeLineChart.plotOptions.series.point.events.select = function() { 
        self.pointSelected = {
          xIndex : this.xIndex,
          yIndex : this.yIndex,
          seriesIndex : this.seriesIndex
        };
      }
      this.timeLineChart.plotOptions.series.point.events.unselect = function(e) { 
        if(e.accumulate === false) {
          self.pointSelected = null; 
        }
      }
      //const translate = (x) => this.translateService(x);
      this.timeLineChart.tooltip.pointFormatter = function () { 
        const toTranslate = (x) => {
          switch (x) {
            case 'Under Investigation' : return 'pages.securitycase.underInvestigationTooltip';
            case 'Escalated' : return 'pages.securitycase.escalatedTooltip';
            case 'Pending Orange Cyberdefense': return 'pages.securitycase.pendingOcdTooltip';
            case 'Closed In Last Hours': return 'pages.securitycase.closedTooltip';
            default : return 'pages.generic.hello';
          }
        }
        const r = self.translateService.instant(toTranslate(this.stage), {numberCases : this.z, casePriority : this.series.name})
        return `
          <table><tr><th colspan="2" style="text-align: center">Cases</th></tr>
          <tr><td colspan="2">${r}</td></tr>
          </table>`  
        },

  
      this.updateDonutFlag = true;
      this.displayTimeLineChart = true;
    })
    .catch(err => {
      this.errorService.handlerError(err);
    })
  }
  calculatePriorityWiseData(data, index, name){
    let dic = {}

    this.xAxis = {};
    this.yAxis = {};
    this.chartData = {};
    
    data.forEach(elem => {
      let x = 0, y = 0, type= "", stage= "", xIndex = 0, yIndex=0;
      if(dic[elem.status] == undefined){
        dic[elem.status] = 1
      }
      else{
        dic[elem.status] = dic[elem.status] + 1
      }
      //setting Y-Axis coordinate
      if (this.customerCases.indexOf(elem.status.toLowerCase()) != -1){
        if (this.yAxis["customerCases"] == undefined){
          this.yAxis["customerCases"] = 1
        }
        else{
          this.yAxis["customerCases"] = this.yAxis["customerCases"] + 1
        }
        y = this.yAxisValue[index]["customerCases"];
        ({x, stage, xIndex} = this.checkXAxis(elem, index));
        type = "Customer";
        yIndex=0
      }
      else {
        y = this.yAxisValue[index]["ocdCases"]
        if (this.yAxis["ocdCases"] == undefined){
          this.yAxis["ocdCases"] = 1
        }
        else{
          this.yAxis["ocdCases"] = this.yAxis["ocdCases"] + 1
        }
        ({x, stage, xIndex} = this.checkXAxis(elem, index));
        type = "Orange Cyberdefense";
        yIndex=1
      }

      if( x!= 0 && y!= 0){
        if(this.chartData[x+","+y+","+type+","+stage+","+xIndex+","+yIndex] == undefined ){
          this.chartData[x+","+y+","+type+","+stage+","+xIndex+","+yIndex] = 1
         }
         else{
          this.chartData[x+","+y+","+type+","+stage+","+xIndex+","+yIndex] = this.chartData[x+","+y+","+type+","+stage+","+xIndex+","+yIndex] + 1
         }
      }
       
     
     
    });

    let seriesData = []
  
    Object.keys((this.chartData)).forEach(key => {
      seriesData.push({
        x: Number(key.split(",")[0]),
        y: Number(key.split(",")[1]),
        z: this.chartData[key],
        name: name,
        stage: key.split(",")[3],
        pendingAt: key.split(",")[2],
        seriesIndex: index,
        xIndex: Number(key.split(",")[4]),
        yIndex: Number(key.split(",")[5])
      });
    })

    this.timeLineChart.series.push(
      {
        name: name,
        data: seriesData,
        marker: {
            fillColor: {
                radialGradient: { cx: 0.4, cy: 0.3, r: 0.7 },
                stops: [
                    [0, 'rgba(255,255,255,0.8)'],
                    [1, this.colors[index]]
                ]
            },
            states : {
              select : {
                fillColor: {
                  radialGradient: { cx: 0.4, cy: 0.3, r: 0.7 },
                  stops: [
                      [0, 'rgba(255,255,255,0.8)'],
                      [1, this.colors[index]]
                  ]
              },
              }
            }
        }
    }
    )

  }
  checkXAxis(data, index){
    let x = 0, xIndex = 0;
    let stage = "";
    if(this.initialInvestigation.indexOf(data.status.toLowerCase()) != -1){
      x = this.xAxisValue[index]["initialInvestigation"]
      xIndex = 0;
      stage= "Under Investigation"
      if (this.xAxis["initialInvestigation"] == undefined){
        this.xAxis["initialInvestigation"] = 1
      }
      else{
        this.xAxis["initialInvestigation"] = this.xAxis["initialInvestigation"] + 1
      }
    }
    else if (this.escalated.indexOf(data.status.toLowerCase()) != -1){
      x = this.xAxisValue[index]["escalated"]
      xIndex = 1;
      stage= "Escalated"
      if (this.xAxis["escalated"] == undefined){
        this.xAxis["escalated"] = 1
      }
      else{
        this.xAxis["escalated"] = this.xAxis["escalated"] + 1
      }
    }
    else if (this.pendingOCD.indexOf(data.status.toLowerCase()) != -1){
      x = this.xAxisValue[index]["pendingOCD"]
      xIndex = 2;
      stage= "Pending Orange Cyberdefense"
      if (this.xAxis["pendingOCD"] == undefined){
        this.xAxis["pendingOCD"] = 1
      }
      else{
        this.xAxis["pendingOCD"] = this.xAxis["pendingOCD"] + 1
      }
    }
    else if (this.closedInLastHours.indexOf(data.status.toLowerCase()) != -1){
/*       let lastModifiedDate: any = new Date(data.lastModifiedDate);
      let latestDate: any = new Date();
      if((Math.abs(latestDate - lastModifiedDate ) /36e5) <= 24){ */
      x = this.xAxisValue[index]["closedInLastHours"]
      xIndex = 3;
      stage = "Closed In Last Hours"
      if (this.xAxis["closedInLastHours"] == undefined){
        this.xAxis["closedInLastHours"] = 1
      }
      else{
        this.xAxis["closedInLastHours"] = this.xAxis["closedInLastHours"] + 1
      }
/*       } */
    }
    else{
      console.log("x 0 ", data.status)
    }
    return {x, stage, xIndex};
  }
}
